export const AllowedDomainsAndAttributeMappingAzureActiveDirectory = '/admin-guide/azure-ad-integration';

export const AzureADIntegrationLink = '/admin-guide/azure-ad-integration';

